<template lang="pug">
    div.wallContent(v-if="wallItem && JSON.stringify(wallItem)!=='{}'")
        div.headBox
            img(alt="", :src="require('../assets/wall_icon/'+wallItem.wallIcon)")
        div.wallName {{wallItem.wallName}}
        div.wallInfoBox
            div.content
                span.contentTitle {{$t("wallContent.wallInfoBoxTitle")}}
                div#wallInfo
                    div(v-for="(item, index) in wallItem.wallInfo", :key="index", class="wallInfoItem")
                        div#wallLevel
                            img(alt="", :src="require('../assets/level'+wallItem.wallInfo[index].level+'.png')")
                        div#wallRight
                            div(v-if="wallItem.wallInfo[index].hp != '' && wallItem.wallInfo[index].hp != '-' && wallItem.wallInfo[index].hp != '0'") HP+{{wallItem.wallInfo[index].hp}}
                            div(v-if="wallItem.wallInfo[index].describe != '' && wallItem.wallInfo[index].describe != '-' && wallItem.wallInfo[index].describe != '0'")
                                img(alt="", :src="require('../assets/wall_skill_icon/'+wallItem.wallInfo[index].describeSkillIcon)")
                                span {{wallItem.wallInfo[index].describe}}
</template>
  
<script>
export default {
    name: 'WeaponModContent',
    data() {
        return {
            wallId:"",
            wallItem:{},
            wallItemList:[]
        }
    },
    created() {
        
    },
    methods:{
        retrieveData(){
            for(let i = 0; i < this.wallItemList.length; i++){
                if(this.wallItemList[i].wallId == this.wallId){
                    this.wallItem = this.$t("wallItemList["+i+"]")
                }
            }
        }
    },
    components:{

    },
    mounted() {
        let wikiData = require("../assets/lang/zh_CN.json")
        this.wallItemList = wikiData.wallItemList
        this.wallId = this.$route.params.id
        this.$nextTick(() => {
            this.retrieveData()
        })
    }
}
</script>

<style lang="scss">
#app{
    background-color: #1c1f1f;
    background: url("../assets/foot_bg.png") center bottom no-repeat;
    background-size: contain;
}
.wallContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    background: url("../assets/weapon_icon_bg.png") center top no-repeat;
    background-size: contain;
    .headBox {
        margin-top: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 90%;
        height: 15%;
        background: url("../assets/wall_list_icon_bg.png") center no-repeat;
        background-size: 100% 100%;
    }
    .headBox img {
        width: 90%;
        //height: 75.6px;
    }
    .wallName {
        margin-top: 70px;
        width: 90%;
        font-size: 32px;
        font-weight: bold;
        color: #dceae3;
        padding: 0 5%;
    }
    .wallInfoBox {
        margin: 22px 0;
        width: 90%;
        color: #dceae3;
    }
    .content {
        float: left;
        width: 100%;
        min-height: 124px;
        background: url("../assets/content_bg.png") top center no-repeat;
        background-size: contain;
        background-color: rgba(0,0,0,0.7);
        border: 1px #212322 solid;
    }
    .contentTitle {
        float: left;
        margin: 15px 0;
        padding-left: 8%;
        width: 92%;
        font-size: 20px;
        line-height: 18px;
        background: url("../assets/title_icon.png") 5% center no-repeat;
        background-size: contain;
    }
    .wallInfoItem {
        float: left;
        position: relative;
        margin: 0 0 0 5%;
        width: 90%;
        border-top: 2px #262a27 solid;
    }
    .wallInfoItem:last-child {
        margin-bottom: 20px;
        border-bottom: 2px #262a27 solid;
    }
    #wallLevel {
        float: left;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: 0;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 30%;
        font-size: 14px;
        text-align: left;
        color: #dceae3;
    }
    #wallLevel img {
        width: 90%;
        justify-content: center;
        align-items: center;
        border: none;
        display: flex;
    }
    #wallRight {
        float: right;
        margin: 0;
        width: 69%;
        border-left: 1px #262a27 solid;
        border-top: none;
        font-size: 14px;
        text-align: left;
        color: #dceae3;
    }
    #wallRight div {
        display: flex;
        //justify-content: center;
        align-items: center;
        padding: 5px 10px;
        border-bottom: 1px #262a27 solid;
    }
    #wallRight div:last-child {
        border-bottom: 0;
    }
    #wallRight div img {
        padding-right: 10px;
        width: 37.28px;
    }
}
</style>